import React from 'react';
import { Lock as LockIcon } from '@mui/icons-material';
import { styled } from '@mui/material';
import { Box } from '@mui/material';

const PREFIX = 'ConfirmationSaveFinal';

const classes = {
  circleContainer: `${PREFIX}-circleContainer`,
  deleteIcon: `${PREFIX}-deleteIcon`,
  textContainer: `${PREFIX}-textContainer`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`& .${classes.circleContainer}`]: {
    backgroundColor: theme.palette.error.light,
    marginBottom: theme.spacing(3),
    borderRadius: '50%',
    width: '80px',
    height: '80px',
  },

  [`& .${classes.deleteIcon}`]: {
    color: '#fff',
  },

  [`& .${classes.textContainer}`]: {
    textAlign: 'center',
    lineHeight: 2,
  },
}));

const ConfirmationSaveFinal = () => (
  <StyledBox display="flex" flexDirection="column" justifyContent="center" alignItems="center">
    <Box display="flex" className={classes.circleContainer} justifyContent="center" alignItems="center">
      <LockIcon className={classes.deleteIcon} fontSize="large" />
    </Box>
    <div className={classes.textContainer}>
      <p>
          You have made changes to a Cap Table that is being used in a Allocation marked as final. These changes will
          alter the final allocation.
      </p>
    </div>
  </StyledBox>
);

export default ConfirmationSaveFinal;
